import '../style.scss';
import './style.scss';
import { Button, ButtonFill, ButtonSize, ButtonType } from 'views/mutual/button';
import { Caption } from 'views/mutual/caption';
import { PersonalAccountOpenPages, usePersonalAccountOpenPageTypeStore } from 'views/pages/accountOpen/personal/hooks';
import { InputTemplate, MaskType } from 'views/templates/module/inputTemplate';
import { UnitInput, UnitInputPosition } from 'views/templates/module/unitInput';
import { AddressInput } from 'views/templates/module/addressInput';
import { BankDetailsInput } from 'views/templates/module/bankDetailsInput';
import { FormContentHeader, FormType } from 'views/templates/module/contentHeader';
import { Selector } from 'views/templates/module/selector';
import { Gender, ImportantPublicWorkerType, AuthModeSelectType, useCustomerInfo } from './hooks';
import { MultiSelections } from 'views/mutual/inputRadio';
import { CheckInput, AlignType } from 'views/templates/module/checkInput';
import { TemplateProps } from '../common';
import {
  PersonalBusinessContentStrs,
} from 'views/utils/enums';

import { useCustomLocationName } from 'views/mutual/location/hooks';
import { MultiCheckInput } from 'views/templates/module/checkInput';
import { PersonalFatcaBase } from './fatca';
import { InputInvoice } from 'views/mutual/invoice';

export type CustomerInfoProps = {
  formik: any;
  customerFirstNameProps: any;
  customerLastNameProps: any;
  customerFirstNameKanaProps: any;
  customerLastNameKanaProps: any;
  genderProps: any;
  customerAddressProps: any;
  customerMobilePhoneProps: any;
  customerHomePhoneProps: any;
  customerFaxNumberProps: any;
  customerMailAddressProps: any;
  customerConfirmMailAddressProps: any;
  occupationProps: any;
  customerMainBusinessContentProps: any;
  customerOtherBusinessContentProps: any;
  purposeProps: any;
  fatcaProps: any;
  importantPublicWorkerProps: any;
  bankDetailsInfoProps: any;
  invoiceNumberProps: any;
  electronicDocumentAgreementProps: any;
  authModeProps: any;
};

export const CustomerInfoWrapper = () => {
  return <CustomerInfo {...useCustomerInfo({ isUpdate: false })} />;
};

export const CustomerInfo = ({
  formik,
  customerFirstNameProps,
  customerLastNameProps,
  customerFirstNameKanaProps,
  customerLastNameKanaProps,
  genderProps,
  customerAddressProps,
  customerMobilePhoneProps,
  customerHomePhoneProps,
  customerFaxNumberProps,
  customerMailAddressProps,
  customerConfirmMailAddressProps,
  occupationProps,
  customerMainBusinessContentProps,
  customerOtherBusinessContentProps,
  purposeProps,
  fatcaProps,
  importantPublicWorkerProps,
  bankDetailsInfoProps,
  invoiceNumberProps,
  electronicDocumentAgreementProps,
  authModeProps,
  isUpdate,
}: CustomerInfoProps & TemplateProps) => {
  const { setAccountOpenPageType } = usePersonalAccountOpenPageTypeStore();
  useCustomLocationName('口座開設申込みフォーム');

  return (
    <form onSubmit={formik.handleSubmit} className="personalAccountOpenTemplate">
      {!isUpdate && (
        <>
          <Caption label="お客様情報" />
        </>
      )}
      <div className="personalAccountOpenTemplate_input">
        <FormContentHeader label="氏名" formType={FormType.Required} />
        <div className="personalAccountOpenTemplate_input_wrapper">
          <UnitInput label="姓" unit={UnitInputPosition.before} placeholder="例：東京" {...customerLastNameProps} />
          <UnitInput label="名" unit={UnitInputPosition.before} placeholder="例：太郎" {...customerFirstNameProps} />
        </div>
        <FormContentHeader label="氏名（フリガナ）" formType={FormType.Required} />
        <div className="personalAccountOpenTemplate_input_wrapper">
          <UnitInput
            label="セイ"
            unit={UnitInputPosition.before}
            placeholder="例：トウキョウ"
            {...customerLastNameKanaProps}
          />
          <UnitInput
            label="メイ"
            unit={UnitInputPosition.before}
            placeholder="例：タロウ"
            {...customerFirstNameKanaProps}
          />
        </div>

        {!isUpdate && (
          <>
          <FormContentHeader label="性別" formType={FormType.Required} />
          <div className="personalAccountOpenTemplate_input_check">
            <MultiSelections
              items={[
                {
                  label: '男性',
                  value: Gender.Male,
                },
                { label: '女性', value: Gender.Female },
                { label: '回答しない', value: Gender.PreferNotToSay },
              ]}
              name="ConfirmAddress"
              {...genderProps}
            />
          </div>
          </>
        )}

        <FormContentHeader label="住所" formType={FormType.Required} />
        <div className="personalAccountOpenTemplate_explanation">
        本人確認書類に記載の住所と同一の住所をご入力ください。
        </div>
        <div className="personalAccountOpenTemplate_input_wrapper">
          <AddressInput name="corporate_address" {...customerAddressProps} />
        </div>
        <FormContentHeader label="電話番号（携帯電話）" formType={FormType.Required} />
        <div className="personalAccountOpenTemplate_input_wrapper">
          <div className="personalAccountOpenTemplate_explanation">
            <a
              className="personalAccountOpenTemplate_input_wrapper_link"
              href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              FPGオンライン取引・電子署名取引一般規約
            </a>
            に定める本件電子署名サービスに使用する電話番号（指定電話番号）として届け出ます。
          </div>
          <InputTemplate
            type="tel"
            placeholder="例：08000000000（ハイフンは不要です）"
            maxLength={11}
            masked={isUpdate ? { type: MaskType.Start, displayedCount: 4 } : undefined}
            {...customerMobilePhoneProps}
          />
        </div>
        <FormContentHeader label="電話番号（固定電話）" formType={FormType.Optional} />
        <div className="personalAccountOpenTemplate_input_wrapper">
          <InputTemplate
            type="tel"
            placeholder="例：0352885692（ハイフンは不要です）"
            maxLength={10}
            masked={isUpdate ? { type: MaskType.Start, displayedCount: 4 } : undefined}
            {...customerHomePhoneProps}
          />
        </div>
        <FormContentHeader label="FAX番号" formType={FormType.Optional} />
        <div className="personalAccountOpenTemplate_input_wrapper">
          <InputTemplate
            type="tel"
            placeholder="例：0352889300（ハイフンは不要です）"
            maxLength={10}
            masked={isUpdate ? { type: MaskType.Start, displayedCount: 4 } : undefined}
            {...customerFaxNumberProps}
          />
        </div>
        <FormContentHeader label="メールアドレス" formType={FormType.Required} />
        <div className="personalAccountOpenTemplate_input_wrapper">
          <div className="personalAccountOpenTemplate_explanation">
            <a
              className="personalAccountOpenTemplate_input_wrapper_link"
              href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              FPGオンライン取引・電子署名取引一般規約
            </a>
            に定める本件電子署名サービスに使用するメールアドレス（指定アドレス）として届け出ます。
          </div>
          <InputTemplate
            type="text"
            placeholder="例：example@example.com"
            masked={isUpdate ? { type: MaskType.End, displayedCount: 4 } : undefined}
            {...customerMailAddressProps}
          />
        </div>
        {isUpdate ? (
          <>
        <FormContentHeader label="メールアドレス（確認用）" formType={FormType.Required} />
        <div className="personalAccountOpenTemplate_input_wrapper">
          <InputTemplate
            type="text"
            placeholder="例：example@example.com"
            masked={isUpdate ? { type: MaskType.End, displayedCount: 4 } : undefined}
            {...customerConfirmMailAddressProps}
          />
        </div>
        </>
        ):(
        <></>
        )}

        <FormContentHeader label="職業" formType={FormType.Required} />
        <div className="personalAccountOpenTemplate_input_check">
          <MultiCheckInput {...occupationProps} />
          {occupationProps.otherText && (
            <InputTemplate
              placeholder="その他を選択された場合は内容を具体的にご記入ください"
              {...occupationProps.otherText}
            />
          )}
        </div>
        {customerMainBusinessContentProps && (
          <>
            <FormContentHeader label="主たる事業内容" formType={FormType.Required} />
            <div className="personalAccountOpenTemplate_input_wrapper">
              <Selector options={PersonalBusinessContentStrs} {...customerMainBusinessContentProps} />
              {customerMainBusinessContentProps.otherText && (
                <InputTemplate
                  type="text"
                  placeholder="その他を選択された場合は内容を具体的にご記入ください"
                  {...customerMainBusinessContentProps.otherText}
                />
              )}
            </div>
          </>
        )}

        {customerOtherBusinessContentProps && (
          <>
            <FormContentHeader label="その他事業内容" formType={FormType.Optional} />
            <div className="personalAccountOpenTemplate_input_wrapper">
              <Selector options={PersonalBusinessContentStrs} {...customerOtherBusinessContentProps} />
              {customerOtherBusinessContentProps.otherText && (
                <InputTemplate
                  type="text"
                  placeholder="その他を選択された場合は内容を具体的にご記入ください"
                  {...customerOtherBusinessContentProps.otherText}
                />
              )}
            </div>
          </>
        )}

        <FormContentHeader label="お取引の目的" formType={FormType.Required} />
        <div className="personalAccountOpenTemplate_input_check">
          <MultiCheckInput items={[]} onChangeItems={() => {}} {...purposeProps} />
          {purposeProps.otherText && (
            <InputTemplate
              placeholder="その他を選択された場合は内容を具体的にご記入ください"
              {...purposeProps.otherText}
            />
          )}
        </div>
        <FormContentHeader label="米国納税義務（FATCA）に関する確認" formType={FormType.Required} />
        <PersonalFatcaBase fatcaProps={fatcaProps}/>
        <FormContentHeader label="外国の重要な公人への該当性" formType={FormType.Required} />
        <div className="personalAccountOpenTemplate_input_check">
          <div className="personalAccountOpenTemplate_explanation">
            外国の重要な公人への該当性は、下記リンク先をご確認のうえご申告ください
            <br />
            <a
              className="personalAccountOpenTemplate_input_wrapper_link"
              href={process.env.REACT_APP_POLITICALLY_EXPOSED_PERSONS_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              「外国の重要な公人該当性」欄のご記入にあたって（法人・個人のお客様共通）
            </a>            
            </div>
            <MultiSelections
              items={[
                {
                  label: '外国の重要な公人もしくはその親族には該当しません',
                  value: ImportantPublicWorkerType.No,
                },
                { label: '外国の重要な公人もしくはその親族に該当します', value: ImportantPublicWorkerType.Yes },
              ]}
              name="ImportantPublicWorker"
              {...importantPublicWorkerProps}
            />
          </div>
          <FormContentHeader label="配当金振り込み用口座" formType={FormType.Required} />
          <div className="personalAccountOpenTemplate_input_wrapper">
             <BankDetailsInput name="bankInput" {...bankDetailsInfoProps}/>
          </div>

        <FormContentHeader label="インボイス番号" formType={FormType.Required} />
        <InputInvoice {...invoiceNumberProps} />

        {!isUpdate && (
          <>
            <FormContentHeader label="電磁的方法による提供の同意・承諾" formType={FormType.Required} />
            <div className="personalAccountOpenTemplate_input_wrapper">
              <CheckInput
                name="electronic_document_agreement"
                label={
                  <>
                    <a
                      className="personalAccountOpenTemplate_input_wrapper_link"
                      href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {'FPGオンライン取引・電子署名取引一般規約 '}
                    </a>
                    {
                      '第5条を確認し、重要事項説明書の交付、契約締結前の情報の提供、契約締結時の情報の提供等の法令で定められた書面の交付、情報提供等を、以下の電磁的方法のうち、当該書面に記載すべき事項の提供又は情報提供等の方法として法令において認められる方法により受けること（電子交付）に承諾します。電子交付に代えて書面の交付を希望する場合にはログイン後に問い合わせフォームから申し出ます。'
                    }
                    <br />
                    <br />
                    {'・電子メールを使用する方法'}
                    <br />
                    {'・弊社のウェブページからダウンロードする方法'}
                    <br />
                    {'・弊社のウェブページに備えられた顧客ファイルを利用する方法'}
                    <br />
                    {'・弊社のウェブページで閲覧に供する方法'}
                    <br />
                    <br />
                    {'※電子交付を受けるには、Acrobat Readerの最新バージョン等が必要です。'}
                  </>
                }
                align={AlignType.start}
                {...electronicDocumentAgreementProps}
              />
            </div>
          </>
        )}
        <FormContentHeader
          label="口座開設後のログインには、セキュリティを強化するための2段階認証が必要となります。2段階認証は、以下のいずれかの方法をお選びいただけます。"
          formType={FormType.Required}
        />
        <div className="personalAccountOpenTemplate_input_check">
            <MultiSelections
              items={[
                {
                  label: 'SMSによる認証　　※携帯電話番号に送信されるSMSメッセージを使用して認証します',
                  value: AuthModeSelectType.SMS,
                },
                { label: 'メールによる認証　　※メールアドレスに送信されるメールを使用して認証します', value: AuthModeSelectType.MailAddress },
              ]}
              name="AuthMode"
              {...authModeProps}
            />
          </div>
      </div>

      {!isUpdate && (
        <div className="personalAccountOpenTemplate_button">
          <Button
            type={ButtonType.Submit}
            label="申込内容の確認へ進む"
            buttonFill={ButtonFill.black}
            buttonSize={ButtonSize.medium}
          />
          <Button
            label="前の画面に戻る"
            buttonFill={ButtonFill.link}
            buttonSize={ButtonSize.small}
            onClick={() => setAccountOpenPageType(PersonalAccountOpenPages.advanceQuestion)}
          />
        </div>
      )}
    </form>
  );
};
